import React, { useContext, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import Button from 'components/UI/Button'
import Link from 'components/Link'
import AuthLogoutButton from 'components/Auth/AuthLogoutButton/AuthLogoutButton'
import { AuthContext, getOrCreateLoginState } from 'components/Auth/Auth'

import './auth-tos.pcss'

const AuthTos = () => {
    const [acceptTosLoading, setAcceptTosLoading] = useState()
    const auth = useContext(AuthContext)
    const { t } = useTranslation('authTos')

    return (
        <div className="auth-tos">
            <div className="auth-tos__title">
                <h2>{t('authTos:modal.title')}</h2>
            </div>
            <p>
                {t('authTos:modal.text1', { email: auth.almaAuthData.user.email })}
            </p>
            <p>
                <Trans i18nKey="authTos:modal.text2">
                    Käyttääksesi Alma Ajo -palveluita, sinun tulee hyväksyä <Link to={t('authTos:modal.almaTermsLink')} trackName="almaTerms">Käyttöehdot.</Link>
                </Trans>
            </p>
            <div className="auth-tos__action">
                <Button
                    className="button"
                    trackName="accept"
                    loading={acceptTosLoading}
                    onClick={() => {
                        setAcceptTosLoading(true)
                        auth.actions.appAuthenticate(auth.almaAuthData.idToken, false, true)
                    }}
                >
                    {t('authTos:modal.cta')}
                </Button>
                <AuthLogoutButton
                    className="button button--secondary"
                    successTarget={getOrCreateLoginState()?.successTarget}
                >
                    {t('authTos:modal.cancel')}
                </AuthLogoutButton>
            </div>
        </div>
    )
}

export default AuthTos
